import { Button, Card, Col, Layout, Modal, Row, notification } from 'antd'
import { PhoneFilled } from '@ant-design/icons'
import React, { useEffect, useState,useRef } from 'react'
import { connect } from 'react-redux'
import { getDashPatientDetails, getDashPatientDetailsLoading } from '../actions/dashboardActions'
// import { loginRet } from '../actions/authActions'
import ClaimAmount from '../Views/ClaimAmount'
import ClaimType from '../Views/ClaimType'
import PatientDetails from '../Views/PatientDetails'
import PatientsBar from '../Views/PatientsBar'
import PatientStats from '../Views/PatientStats'
import FillPatientDetails from '../Views/FillPatientDetails'
import Cookies from 'js-cookie'
import axios from 'axios'
import { get_v10_url } from '../utils/commonUtilities'
import DashboardIcon from '../Assets/images/sidebar-icons/Dashboard.svg'

const helpDeskIcon = (
  <svg width="20" height="30" viewBox="0 0 281 321" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M97.9092 220.5H79.8164C35.7354 220.5 0 256.235 0 300.316C0 311.464 9.03613 320.5 20.1836 320.5H260.816C271.964 320.5 281 311.464 281 300.316C281 256.235 245.265 220.5 201.184 220.5H183.091C170.269 226.9 155.805 230.5 140.5 230.5C125.195 230.5 110.731 226.9 97.9092 220.5Z" fill="white"/>
  <path d="M183.647 159.76C183.766 160.005 183.881 160.251 183.993 160.5H188C201.941 160.5 213.862 151.855 218.697 139.634C220.202 133.503 221 127.095 221 120.5C221 76.3171 185.183 40.5 141 40.5C96.8174 40.5 61 76.3171 61 120.5C61 145.764 72.7109 168.292 91 182.954V179.5C91 157.961 108.461 140.5 130 140.5H153C157.607 140.5 162.001 141.417 166.008 143.077C173.738 146.281 180.031 152.254 183.647 159.76Z" fill="white"/>
  <path d="M110 179.107C110 168.278 118.778 159.5 129.607 159.5H151C162.046 159.5 171 168.454 171 179.5H196.5C220.524 179.5 240 160.024 240 136V114.016C240 62.6449 198.355 21 146.984 21H140.25C85.1596 21 40.5 65.6596 40.5 120.75V130C40.5 135.799 35.799 140.5 30 140.5C24.201 140.5 19.5 135.799 19.5 130V120.291C19.5 53.8562 73.3562 0 139.791 0H143.249C208.557 0 261.5 52.9429 261.5 118.251V128C261.5 168.593 228.593 201.5 188 201.5H131C119.402 201.5 110 192.098 110 180.5V179.107Z" fill="white"/>
  </svg>
)

function Home(props) {

  useEffect(() => {
    scrollToTop()
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
  const inputRef = useRef(null);
  const [elementHeight, setElementHeight] = useState(1300);
  const [innerWidth, setInnerWidth] = useState(1280)
  const [helpModal, setHelpModal] = useState(false)

  useEffect(() => {
    if (inputRef.current) {
      const height = inputRef.current.offsetHeight;
      setElementHeight(height);
    }
    setInnerWidth(window.innerWidth)
  }, []);

  const getInTouch = async () => {
    const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get("token_medical_auth")}` } }
    try {         
        const apiData = await axios.get(`${get_v10_url()}/professional/contactAgent`, headers)
        if(apiData?.data?.success) {
          notification["success"]({
            message: 'Contact',
            description: apiData?.data?.msg,
          })
          setHelpModal(false)
        }
        else {
          notification["error"]({
            message: 'Contact',
            description:
              'An Error Occured please try again later',
          })
        }
    } catch (error) {
      let errMsg = error?.response?.data?.msg ? error?.response?.data?.msg : 'An Error Occured please try again later'
      notification["error"]({
        message: 'Contact',
        description: errMsg,
      })
        // yield put(loginError())
    }
  }

  return (
    <div className="dasboard-container">
      <Card title={
        <Row align="middle" justify="space-between">
          <Col span={innerWidth <= 1280 ? 19 : 20} style={{display:'flex', alignItems:'center', gap:'0.75rem'}}>
            <img src={DashboardIcon} alt='icon' style={{filter:'invert(61%) sepia(66%) saturate(4119%) hue-rotate(110deg) brightness(103%) contrast(105%)', height:'28px', width:'auto'}}/>
            <h1 style={{marginBottom: "0", color:'#01D35A'}}>Dashboard</h1></Col>
          <Col span={innerWidth <= 1280 ? 5 : 4}><Button style={{width: "100%", fontSize: `${innerWidth <= 1280 ? '1rem' : '1.1rem'}`, height: "100%", borderRadius: "0.5rem", marginTop: '-4px', display:'flex', alignItems:'center', gap:'0.5rem', justifyContent:'center'}} type='danger' onClick={() => setHelpModal(true)}>{helpDeskIcon} <span style={{marginTop:'2px'}}>Help Desk</span></Button></Col>
        </Row>} headStyle={{ marginLeft: '185px', height: '64px' }} bodyStyle={{ height: 'calc(100vh - 65px)', overflowY: 'scroll', backgroundColor:'#F2F5FA' }}>
          <Row gutter={24}>
            <Col span={13} ref={inputRef}>
              <FillPatientDetails />
              <PatientStats />
              <ClaimAmount />
              <ClaimType />
            </Col>
            <Col span={11}>
              <PatientDetails maxHeight={elementHeight} />
            </Col>
          </Row>
          <PatientsBar />
        </Card>
        <Modal
          open={helpModal}
          onCancel={() => setHelpModal(false)}
          onOk={() => setHelpModal(false)}
          className='help-desk-modal'
          width={'40%'}
        >
          <div className='modal-container'>
            <h1>How can we assist you?</h1>
            <p>Our team is just a call away. Click "Call" below, and we will connect you with one of our customer service representatives right away.</p>
            <div className='btn-container'>
              <Button className='call-btn' icon={<PhoneFilled style={{rotate:'90deg'}}/>} onClick={()=>getInTouch()}>Call</Button>
            </div>
          </div>
        </Modal>
      </div>
  )
}

export default Home;